import 'react';
import { isLinkHotspotItem } from '@i-ark/models';
import { LinkHotspot } from './LinkHotspot.js';
import { SpeechSynthesisHotspot } from './SpeechSynthesisHotspot.js';
import { jsx } from 'react/jsx-runtime';

const Hotspot = ({
  item,
  ...props
}) => {
  return isLinkHotspotItem(item) ? /*#__PURE__*/jsx(LinkHotspot, {
    item: item,
    ...props
  }) : /*#__PURE__*/jsx(SpeechSynthesisHotspot, {
    item: item,
    ...props
  });
};

export { Hotspot };
//# sourceMappingURL=Hotspot.js.map
